import { providerRegistry } from './providerRegistry';
import { GoogleProvider } from './providers/GoogleProvider';
// Future providers can be imported here:
// import { GitHubProvider } from './providers/GitHubProvider';
// import { FacebookProvider } from './providers/FacebookProvider';

/**
 * Initialize and register all OAuth providers from environment configuration
 * This should be called once at app startup
 */
export function initializeOAuthProviders(): void {
  // Google Provider
  const googleClientId = import.meta.env.VITE_GOOGLE_OAUTH_CLIENT_ID;
  if (googleClientId) {
    const googleProvider = new GoogleProvider({
      clientId: googleClientId,
      scopes: ['openid', 'email', 'profile'],
    });
    providerRegistry.registerProvider(googleProvider);
    console.log('Google OAuth provider registered');
  } else {
    console.warn('VITE_GOOGLE_OAUTH_CLIENT_ID not found. Google OAuth will not be available.');
  }

  // Future providers can be added here following the same pattern:
  // 
  // const githubClientId = import.meta.env.VITE_GITHUB_OAUTH_CLIENT_ID;
  // if (githubClientId) {
  //   const githubProvider = new GitHubProvider({
  //     clientId: githubClientId,
  //     scopes: ['user:email'],
  //   });
  //   providerRegistry.registerProvider(githubProvider);
  //   console.log('GitHub OAuth provider registered');
  // }
}

/**
 * Get server-side provider configuration
 * Used by edge functions to get provider instances with client secrets
 */
export function createServerProvider(providerId: string, clientSecret: string): any {
  const clientId = Deno.env.get(`VITE_${providerId.toUpperCase()}_OAUTH_CLIENT_ID`) ||
                   Deno.env.get(`${providerId.toUpperCase()}_OAUTH_CLIENT_ID`);

  if (!clientId) {
    throw new Error(`Client ID not found for provider: ${providerId}`);
  }

  switch (providerId.toLowerCase()) {
    case 'google':
      return new GoogleProvider({
        clientId,
        clientSecret,
        scopes: ['openid', 'email', 'profile'],
      });
    
    // Future providers:
    // case 'github':
    //   return new GitHubProvider({
    //     clientId,
    //     clientSecret,
    //     scopes: ['user:email'],
    //   });
    
    default:
      throw new Error(`Unknown provider: ${providerId}`);
  }
}
